import React, {useEffect, useState} from 'react';
import ClientRAPI from "../API/ClientRAPI";
import {useNavigate, useParams} from "react-router-dom";
import ReactInputMask from "react-input-mask";
import InfoCard from "../components/UI/InfoCard";
import {toast} from "react-toastify";
import ClientFields from "../components/Client/Fields";

const ClientDetail = () => {
    let {id} = useParams()
    const navigate = useNavigate();
    const [client, setClient] = useState({})

    async function fetch() {
        const res = await ClientRAPI.getById(id)
        setClient(res)
    }

    async function saveClient() {
        const res = await ClientRAPI.addClient(client)

        if (res.error) {
            toast.error(res.error)
        } else {
            setClient(res)
            toast.success('Данные успешно сохранены')
        }
    }

    function addRepres() {
        let r = {...client}
        r.represes.push({p: '', f: ''})
        setClient(r)
    }

    function removeRepres(k) {
        let r = {...client}
        r.represes.splice(k, 1);
        setClient(r)
    }

    function changeRepresPhone(k, value) {
        let r = {...client}
        r.represes[k].p = value
        setClient(r)
    }
    function changeRepresFIO(k, value) {
        let r = {...client}
        r.represes[k].f = value
        setClient(r)
    }

    useEffect(function() {
        fetch()
    }, [])

    function statusClass(statuses) {
        switch (statuses.join('')) {
            case '0':
            case '01':
            case '02':
                return 'bg-gradient-light'
            case '1':
            case '12':
                return 'bg-gradient-warning'
            case '2':
                return 'bg-gradient-success'
            case '23':
                return 'bg-gradient-info'
            default:
                return 'bg-gradient-danger'
        }
    }
    function statusName(statuses) {
        switch (statuses.join('')) {
            case '0':
            case '01':
            case '02':
                return 'В работе'
            case '1':
            case '12':
                return 'Ждет выдачи'
            case '2':
                return 'Закрыт'
            case '23':
                return 'Требует проверки'
        }

        return statuses.join('')
    }

    return (
        <div>
            <h3><span className="text-secondary">Клиент:</span> {client.last_name} {client.name} {client.second_name} <span className="py-1 px-2 badge bg-gradient-warning text-sm">{client.type}</span></h3>
            <div className="row">
                <div className="col-md-8">
                    <ClientFields client={client} setClient={setClient}/>
                </div>
                <div className="col-md-4">
                    {client.stat &&
                    <InfoCard minContent={true} style={{ height: 'min-content !important'}} title="Статистика" elements={[
                        {label: 'Количество заказов', value: Intl.NumberFormat("ru").format(client.stat.order.cnt)},
                        {label: 'Общая сумма', value: Intl.NumberFormat("ru").format(parseInt(client.stat.order.sum))},
                        {label: 'Средний чек', value: Intl.NumberFormat("ru").format(parseInt(client.stat.order.avg))},
                    ]}/>
                    }

                    <h6 className="mt-3">Представители</h6>
                    {client.represes && client.represes.map((el, k) =>
                        <div className="input-group mb-3">
                            <ReactInputMask mask="+7 (999) 999-99-99" type="text" className="form-control"
                                            placeholder="Номер телефона" value={el.p}
                                            onChange={(e) => changeRepresPhone(k, e.target.value)}
                            />
                            <input type="text" placeholder="ФИО" value={el.f} onChange={(e) => changeRepresFIO(k, e.target.value)} className="form-control"/>
                            <button className="btn bg-gradient-primary mb-0" onClick={() => removeRepres(k)}>X</button>
                        </div>
                    )}
                    <button className="btn bg-gradient-primary" onClick={addRepres}>+ Добавить</button>
                </div>
            </div>
            <div className="row">
                <div className="col-md-4">
                </div>
                <div className="col-md-4">
                    <h6>&nbsp;</h6>
                    <button className="btn bg-gradient-success" onClick={saveClient}>Сохранить</button>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-md-8">
                    <h6>Заказы</h6>
                    <div className="card" style={{overflowX: 'scroll'}}>
                        <table className="table text-center">
                            <thead>
                                <tr>
                                    <th>№</th>
                                    <th>Дата</th>
                                    <th>Сумма</th>
                                    <th>Оплачено</th>
                                    <th>Статус</th>
                                </tr>
                            </thead>
                            <tbody>
                                {client.orders && client.orders.map(el =>
                                    <tr onClick={() => navigate('/orders/' + el.id)}>
                                        <td>{el.id}</td>
                                        <td>{el.created_at}</td>
                                        <td>{Intl.NumberFormat("ru").format(el.total_summ)}</td>
                                        <td className={el.total_summ !== el.payed_summ?'text-danger':''}>{Intl.NumberFormat("ru").format(el.payed_summ)}</td>
                                        <td><span className={"badge " + statusClass(el.statuses)}>{statusName(el.statuses)}</span></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-4">
                    <h6>Статистика по годам</h6>
                    <div className="card">
                        <table className="table text-center">
                            <thead>
                            <tr>
                                <th>№</th>
                                {client.chart && client.chart.years && client.chart.years.map(el =>
                                    <th>{el}</th>
                                )}
                            </tr>
                            </thead>
                            <tbody>
                            {client.chart && client.chart.data.map((el, k) =>
                                <tr>
                                    <td>{el.name}</td>
                                    {client.chart && client.chart.years && client.chart.years.map((year, key) =>
                                        <td>{Intl.NumberFormat("ru").format(el.data[key])}</td>
                                    )}
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientDetail;